export enum SpinnerSize {
    small = 'small',
    large = 'large',
}
